export const transactions = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Transactions",
};
